import React from 'react';
import {GRANITE_6} from '../../colors';
import Menu from '@material-ui/core/Menu';
import theme from '../../theme';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@material-ui/core/Tooltip';
import MenuItemAnchor from './MenuItemAnchor';
import omit from 'lodash/omit';
import withWidth from '@material-ui/core/withWidth';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function isVisible(user) {
    return user.isAuthenticated;
}

class Toolbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }

    render() {
        if (!isVisible(this.props.user)) return null;

        return (<React.Fragment>
            {this.renderButton()}
            {this.renderMenu()}
        </React.Fragment>);
    }

    renderButton() {
        return (<a
            {...omit(this.props, 'user')}
            ref={this.ref}
            href="#"
            onClick={event => {
                event.preventDefault();
                this.setState({open: true});
            }}
            style={{
                ...this.props.style,
                paddingRight: 0,
                paddingLeft: theme.spacing.unit
            }}
        >
            { this.props.children || this.renderButtonInner() }
        </a>);
    }

    renderButtonInner() {
        const {user, width} = this.props;

        return (<React.Fragment>
            <div style={{
                padding: 2,
                borderColor: GRANITE_6,
                borderWidth: 1,
                borderRadius: '100%',
                borderStyle: 'solid'
            }}>
                <Avatar
                    alt={user.displayName}
                    style={{
                        width: 28,
                        height: 28,
                        borderRadius: '100%',
                        borderStyle: 'none'
                    }}
                    src={user.image}
                />
            </div>

            {user.isSU && <Tooltip title={`Warning! Logged in as "${user.displayName}".`}>
                <WarningIcon style={{marginRight: theme.spacing.unit / 2}} color='secondary' />
            </Tooltip>}

            {width === 'md' || width === 'sm' || width === 'xs' ?
                null :
                <span style={{paddingLeft: 6}}>{user.displayName}</span>
            }

            <ExpandMoreIcon style={{fontSize: 18}} />
        </React.Fragment>);
    }

    renderMenu() {
        return (<Menu
            anchorEl={this.ref.current}
            open={this.state.open}
            onClose={() => this.setState({open: false})}
        >
            <HamburgerMenu user={this.props.user} />
        </Menu>);
    }
}

function HamburgerMenu(props) {
    if (!isVisible(props.user)) return null;
    const {user} = props;

    return (<React.Fragment>
        <MenuItemAnchor href="/datasummary/tracks/">{gettext('Tracks')}</MenuItemAnchor>
        <MenuItemAnchor href="/datasummary/routes/">{gettext('Routes')}</MenuItemAnchor>
        { user.hasSubscription ?
            <MenuItemAnchor href="/datasummary/areas/">{gettext('Areas')}</MenuItemAnchor> :
            null }
        <MenuItemAnchor href="/datasummary/waypoints/">{gettext('Waypoints')}</MenuItemAnchor>
        <MenuItemAnchor href="/datasummary/photos/">{gettext('Photos')}</MenuItemAnchor>
        <MenuItemAnchor href="/datasummary/maps/">{gettext('Maps')}</MenuItemAnchor>
        <MenuItemAnchor href="/datasummary/mapsources/">{gettext('Map Sources')}</MenuItemAnchor>
        <MenuItemAnchor href="/datasummary/folders/">{gettext('Folders')}</MenuItemAnchor>

        <Divider />
        <MenuItemAnchor href="/upload/">{gettext('Upload')}</MenuItemAnchor>
        <Divider />
        { user.isTeamAdmin ?
            <MenuItemAnchor href="/teams/">My Teams</MenuItemAnchor> :
            null }
        <MenuItemAnchor href="/team/">Create a Team</MenuItemAnchor>

        <Divider />
        <MenuItemAnchor href="/profile/">{gettext('My Profile')}</MenuItemAnchor>
        <MenuItemAnchor href="/user/subscriptions/">{gettext('My Subscriptions')}</MenuItemAnchor>
        <MenuItemAnchor href="/user/password/change/">{gettext('Change Password')}</MenuItemAnchor>
        <MenuItemAnchor href="/notifications/manage/">{gettext('Notification Settings')}</MenuItemAnchor>
        <MenuItemAnchor href="/logout/">{gettext('Log out')}</MenuItemAnchor>

        { user.isStaff ? <React.Fragment>
            <Divider />
            <MenuItemAnchor href="/report/paid_subs/">Marketing Stats</MenuItemAnchor>
            <MenuItemAnchor href="/dashboard/">GaiaCloud Stats</MenuItemAnchor>
            <MenuItemAnchor href="/admin/">Datastore</MenuItemAnchor>
            <MenuItemAnchor href="/giftcodes/">Generate Gift Code</MenuItemAnchor>
            <MenuItemAnchor href="/giftcodes/use/">Apply Gift Code</MenuItemAnchor>
        </React.Fragment> : null }
    </React.Fragment>);
}

export default { Toolbar: withWidth()(Toolbar), HamburgerMenu };
